import validationRuleCreator from './validationRuleCreator';

type TValue = RegExp;

const regExpValidator = (value: TValue, message: string) =>
  validationRuleCreator<TValue>('pattern', value, message);

export default regExpValidator;
